import { Card, Col, Container, Row } from "react-bootstrap";
import { useBootstrapAuthSessionQuery } from "../new/auth.query";
import useAuthSessionStore from "../stores/auth-session-store";
import styles from "../styles/auth-session-bootstrap.module.css";
import authStyles from "../styles/auth-pages.module.css";

const progressUpdates = {
    checkingSavedSession: {
        title: "Checking saved sign-in",
        detail: "Looking for an active secure session on this device."
    },
    refreshingAccess: {
        title: "Refreshing secure access",
        detail: "Requesting a fresh access token from the server."
    },
    restoringWorkspace: {
        title: "Preparing your workspace",
        detail: "Restoring your session so you can continue right where you left off."
    }
};

const AuthSessionBootstrap = ({ children }) => {
    const sessionBootstrapStatus = useAuthSessionStore((state) => state.sessionBootstrapStatus);
    const sessionBootstrapStep = useAuthSessionStore((state) => state.sessionBootstrapStep);
    const bootstrapQuery = useBootstrapAuthSessionQuery();
    const isBootstrapping = sessionBootstrapStatus === "pending" || bootstrapQuery.isLoading;
    const activeUpdate = progressUpdates[sessionBootstrapStep] ?? progressUpdates.checkingSavedSession;

    if (isBootstrapping) {
        return (
            <Container fluid className={authStyles.authViewport}>
                <div className={authStyles.authShell}>
                    <div className={authStyles.formColumn}>
                        <Row className={authStyles.authRow}>
                            <Col xs={12} className={`${authStyles.authCol} ${styles.bootstrapCol}`}>
                                <Card className={`${authStyles.authCard} ${styles.bootstrapCard}`}>
                                    <Card.Img
                                        className={authStyles.banner}
                                        variant="top"
                                        src="../KTMAHEADER.png"
                                        alt="Money Follows The Person Banner"
                                    />
                                    <Card.Body className={`${authStyles.cardBody} ${styles.cardBody}`}>
                                        <div className={styles.loader} aria-hidden="true">
                                            <span className={styles.spinner} />
                                        </div>
                                        <div className={styles.copyBlock}>
                                            <p className={styles.eyebrow}>Signing You In</p>
                                            <h3 className={authStyles.title}>Restoring your secure session</h3>
                                            <p className={`${authStyles.subtitle} ${styles.subtitle}`}>
                                                Checking your credentials so you can pick up right where you left off.
                                            </p>
                                            <div className={styles.statusPanel} aria-live="polite">
                                                <p className={styles.statusTitle}>{activeUpdate.title}</p>
                                                <p className={styles.statusDetail}>{activeUpdate.detail}</p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>
        );
    }

    return children;
};

export default AuthSessionBootstrap;
